export default __webpack_public_path__ + "static/media/marian.e709488e.png";